import { get, post, put } from "../../config/api";

export const Card = {
  add: (payload: { cardNumber: string; currencyCode: "string" }) =>
    post(`teckcards`, { json: { ...payload } }),
  getAll: (page = 1, limit = 10) =>
    get(`teckcards?page=${page}&limit=${limit}`),
  updateBalance: (id: string) => put(`teckcards/${id}/balance`),
};
